import pinia from "@/stores";
import { useAuthStore } from "@/stores/auth";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import RegisterView from "../views/RegisterView.vue";
import RecoveryView from "../views/RecoveryView.vue";
import PasswordView from "../views/PasswordView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      hasMenu: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView,
  },
  {
    path: "/recovery",
    name: "recovery",
    component: RecoveryView,
  },
  {
    path: "/password/:token",
    name: "password",
    component: PasswordView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const loginStore = useAuthStore(pinia);
  if (to.name === "home" && !loginStore.isLogged) {
    return next("/login");
  }
  if (
    to.name &&
    ["register", "recovery"].includes(to.name) &&
    loginStore.isLogged
  ) {
    return next("/");
  }

  return next();
});

export default router;
